const getValue = (value, fallback) => {
  const resolved = ko.toJS(value);
  return resolved === undefined ? fallback : resolved;
};

export class ViewModel {
  constructor(params, element) {
    this.element = element;
    this.label = params.label;
    this.icon = params.icon;
    this.href = params.href;
    this.target = params.target;
    this.tooltip = params.tooltip;

    this.isCollapsed = ko.observable(this._checkCollapsed());
    this._setupCollapsedObserver();

    this.active = ko.computed(() => Boolean(getValue(params.active, false)));
    this.disabled = ko.computed(() => Boolean(getValue(params.disabled, false)));

    this.classes = ko.computed(() => {
      const classes = [
        "sidebar__item-link",
        "vap-sidebar__item-link",
      ];

      const itemId = getValue(params.id, "");
      if (itemId) classes.push(`sidebar__item-link--${itemId}`);

      if (this.active()) classes.push("active");
      if (this.disabled()) classes.push("sidebar__item-link--disabled");
      if (getValue(this.icon)) classes.push("sidebar__item-link--has-svg");

      const extraClass = getValue(params.extraClass, "");
      if (extraClass) classes.push(extraClass);

      return classes.join(" ");
    });

    this.linkAttrs = ko.computed(() => {
      const attrs = {};
      const href = getValue(this.href);
      const target = getValue(this.target);

      if (!this.disabled() && href) {
        attrs.href = href;
      }

      if (target) {
        attrs.target = target;
      }

      const tooltip = getValue(this.tooltip);
      if (tooltip) attrs.title = tooltip;

      return attrs;
    });

    this.onClick = (_, event) => {
      if (this.disabled()) {
        event.preventDefault();
        return false;
      }
      if (typeof params.click === "function") {
        params.click(event);
      }
      return true;
    };
  }

  _checkCollapsed() {
    const sidebar = this.element.closest('.app__sidebar');
    return sidebar ? sidebar.classList.contains('app__sidebar--small') : false;
  }

  _setupCollapsedObserver() {
    const sidebar = this.element.closest('.app__sidebar');
    if (!sidebar) return;

    this._mutationObserver = new MutationObserver(() => {
      this.isCollapsed(this._checkCollapsed());
    });

    this._mutationObserver.observe(sidebar, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  dispose() {
    if (this._mutationObserver) {
      this._mutationObserver.disconnect();
    }
  }
}
